import Icon from "@mui/icons-material/PersonOutline";
import MyAttendancePage from "./MyAttendancePage";

export default {
  list: MyAttendancePage,
  icon: Icon,
  label: "My dashboard",
  options: { label: "My dashboard" },
  name: "myAttendance",
};
